module.exports = __webpack_public_path__ + "src/assets/video/howToPlayNewHive.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/howToPlayNewHive.gif
// module id = ./src/assets/video/howToPlayNewHive.gif
// module chunks = 0